import { render, staticRenderFns } from "./MethodComp.vue?vue&type=template&id=febac446&scoped=true&"
import script from "./MethodComp.vue?vue&type=script&lang=js&"
export * from "./MethodComp.vue?vue&type=script&lang=js&"
import style0 from "./MethodComp.vue?vue&type=style&index=0&id=febac446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febac446",
  null
  
)

export default component.exports